import { useRef, useEffect, useState, FormEvent } from "react";
import { Footer, Navbar, NavbarUser } from '../../containers';
import ContactForm from './contactform';
import './contact.css';
import { useTranslation } from 'react-i18next';
import api from '../../api/axios';

const ContactSite = () => {

    const { t } = useTranslation();
    // Footer berechnen
    const footerRef = useRef(null);
    const [footerHeight, setFooterHeight] = useState(0);
    // Navbar berechnen
    const [navbarHeight, setNavbarHeight] = useState(0);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [contactPersonSrc, setContactPersonSrc] = useState("");
    const [speechBubbleSrc, setSpeechBubbleSrc] = useState("");
    const [pictureSrc, setPictureSrc] = useState("");

    useEffect(() => {
        const token = sessionStorage.getItem("token");
        setIsAuthenticated(!!token);

        // Footer height calculation
        if (footerRef.current) {
            setFooterHeight(footerRef.current.clientHeight);
        }

        // Navbar height calculation
        const navbarElement = document.querySelector('.navbarHomepage');
        if (navbarElement) {
            const navbarHeight = navbarElement.offsetHeight;
            setNavbarHeight(navbarHeight);
        }
    }, []); // Empty dependency array to ensure it runs only once on mount

    useEffect(() => {
        const fetchPictures = async () => {
            try {
                // 🔹 Hardcoded IDs for each image (adjust to your DB)
                const [contactPersonId, speechBubbleId, backgroundId] = [13, 14, 22];

                // Call all three routes in parallel
                const [contactPersonRes, speechBubbleRes, backGroundRes] = await Promise.all([
                    api.get(`/user/getwebsitepicture/${contactPersonId}`),
                    api.get(`/user/getwebsitepicture/${speechBubbleId}`),
                    api.get(`/user/getwebsitepicture/${backgroundId}`),
                ]);

                setContactPersonSrc(contactPersonRes.data.picture);
                setSpeechBubbleSrc(speechBubbleRes.data.picture);
                setPictureSrc(backGroundRes.data.picture);
            } catch (err) {
                console.error("Error fetching one or more pictures:", err);
            }
        };

        fetchPictures();
    });

    return (
        <div className="wrapper-contact-form" style={{
            backgroundImage: pictureSrc ? `url(${pictureSrc})` : 'none'
        }}>
            {isAuthenticated ? <NavbarUser /> : <Navbar />}
            <div className="contact-form-everything" style={{ minHeight: `calc(100vh - ${footerHeight}px)` }}>
                <div className="sup-parent">
                    {contactPersonSrc ? (
                        <img className="sup-icon" src={contactPersonSrc} alt="icon konnte nicht geladen werden." style={{ marginBottom: footerHeight }} />
                    ) : (
                        <p>{t('LoadingPicture')}</p>
                    )}
                    <div className="speech-bubble-container" style={{ marginBottom: footerHeight }}>
                        {speechBubbleSrc ? (
                            <img className="speech-bubble" src={speechBubbleSrc} alt="speech bubble" />
                        ) : (
                            <p>{t('LoadingPicture')}</p>
                        )}
                    </div>
                </div>
                <div className="contact-form-container" style={{ marginTop: navbarHeight + 1 }}>
                    <h2>{t('ContactUs')}</h2>
                    <ContactForm />
                </div>
            </div>
            <div ref={footerRef}>
                <Footer />
            </div>
        </div>
    );
};

export default ContactSite;